export enum NotificationActionType {
    Popup = 1,    
}
